import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress,
} from '@mui/material'

import { Auth } from '@edge/spark/io-aws'
import { useDialog, clearDialog } from '../dialog.store'
import { removeSessionCookie } from '../utils/cookieUtils'
import { IfOfferResultsList } from './components/OfferResultsList'
import { IfOfferUpdateResult } from './components/types'

export const AppDialog: React.FC = () => {
    const { heading, message, messageList, action, type } = useDialog() || {}

    const handleClickAction = async (): Promise<void> => {
        console.debug('feature-dialog handleClickAction', action)

        switch (action) {
            case 'SPINNER':
                break
            case 'UPDATE':
                clearDialog()
                break
            case 'LOGOUT':
                clearDialog()
                removeSessionCookie()
                console.debug('AppDialog LOGOUT. Signing out...')
                await Auth.signOut()
                break
            case 'REFRESH':
                clearDialog()
                /* @ts-expect-error true parameter only works in firefox: https://developer.mozilla.org/en-US/docs/Web/API/Location/reload */
                window.location.reload(true)
                break
            default:
                await clearDialog()
        }
    }

    if (type === 'LIST') {
        return (
            <Dialog aria-labelledby="offer-results-list-dialog" open>
                <DialogContent sx={{ p: 0 }}>
                    <IfOfferResultsList results={(messageList ?? []) as IfOfferUpdateResult[]} />
                </DialogContent>
                {action && (
                    <DialogActions>
                        {action === 'SPINNER' ? (
                            <Button variant="outlined" disabled color="primary">
                                <CircularProgress size={14} color="primary" />
                            </Button>
                        ) : (
                            <Button onClick={handleClickAction} color="primary">
                                {action}
                            </Button>
                        )}
                    </DialogActions>
                )}
            </Dialog>
        )
    }

    if (type !== 'ALERT' || !message) {
        return <div />
    }

    return (
        <Dialog open>
            {heading && <DialogTitle>{heading}</DialogTitle>}
            {message && (
                <DialogContent>
                    <DialogContentText>{message}</DialogContentText>
                </DialogContent>
            )}

            {action && (
                <DialogActions>
                    {action === 'SPINNER' ? (
                        <Button variant="outlined" disabled color="primary">
                            <CircularProgress size={14} color="primary" />
                        </Button>
                    ) : (
                        <Button onClick={handleClickAction} color="primary">
                            {action}
                        </Button>
                    )}
                </DialogActions>
            )}
        </Dialog>
    )
}
